import React from "react"

import {
  Box,
  Divider,
  Typography
} from "@material-ui/core"

// Styles
import { useClasses, joinClasses } from "../globals"

export const Title = ({title}) => {
  
  if (!title) {
    return false;
  }
  
  const classes = useClasses()

  return (
    <React.Fragment>
      <Divider />
      <Box
        className={joinClasses(
          classes._TextAlignCenter,
          classes._PaddingDouble
        )}
      >
        <Typography variant="h2" color="primary">
          {title}
        </Typography>
      </Box>
      <Divider />
    </React.Fragment>
  )
}